// import { ArrowUp } from "lucide-react"; // temporarily unused (scroll-to-top disabled)
// import { motion, AnimatePresence } from "framer-motion"; // temporarily unused
// import { useState, useEffect } from "react"; // temporarily unused (scroll-to-top disabled)
import { Link, useLocation } from "react-router-dom";

const informationLinks = [
  { label: "About Us",          path: "/about" },
  { label: "Privacy Policy",    path: "/privacy-policy" },
  { label: "Terms & Conditions", path: "/terms-conditions" },
];

const categoryLinks = [
  { label: "Best Selling",     path: "/products/best-selling-medicines" },
  { label: "Super Speciality", path: "/products/super-speciality-medicines" },
  { label: "Surgicals",        path: "/products/surgicals" },
  { label: "Vaccines",         path: "/products/vaccines" },
  { label: "All Medicines",    path: "/products/all" },
];



export default function Footer() {
  const location = useLocation();
  const isMedicineDetailPage = location.pathname.startsWith('/medicine/');
  /* scroll-to-top state/logic – temporarily disabled
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const fn = () => setShowScrollTop(window.scrollY > 500);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  */
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="relative bg-white">

      {/* ── Teal accent bar ── */}
      <div className="h-1 w-full bg-gradient-to-r from-[#1a7a8a] to-[#2c9dae]" />

      {/* ── Main footer body ── */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 fold:grid-cols-2 md:grid-cols-2 lg:grid-cols-6 gap-8 sm:gap-10">

          {/* ── Col 1-2: Brand ── */}
          <div className="lg:col-span-2 space-y-5">
            <div>
              <img
                src="/images/Essess_Logo-cropped.svg"
                alt="eSSeSSpharma"
                width="160"
                height="40"
                className="h-10 w-auto object-contain"
              />
              <p className="text-xs text-[#2badb8] mt-1 font-semibold tracking-wide uppercase">Pharmaceutical Exports</p>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed max-w-xs">
              eSSeSSPHARMA FZ LLC — a globally trusted pharmaceutical distribution company delivering certified medicines and healthcare solutions to 45+ countries.
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-3 pt-1">
              <a href="https://wa.me/971545012567" target="_blank" rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-[#eef3f7] hover:bg-[#25D366] flex items-center justify-center transition-colors duration-200 group">
                <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-gray-400 group-hover:text-white" fill="currentColor">
                  <path d="M20.52 3.48A11.93 11.93 0 0012 0C5.37 0 0 5.37 0 12a11.9 11.9 0 001.64 6.08L0 24l6.1-1.6A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.22-3.48-8.52zM12 22a9.93 9.93 0 01-5.06-1.38l-.36-.21-3.74.98.99-3.63-.24-.38A9.94 9.94 0 012 12C2 6.48 6.48 2 12 2c2.65 0 5.15 1.03 7.03 2.9A9.9 9.9 0 0122 12c0 5.52-4.48 10-10 10zm5.47-7.38c-.3-.15-1.77-.87-2.04-.97-.28-.1-.48-.15-.68.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07a8.14 8.14 0 01-2.4-1.48 9 9 0 01-1.66-2.07c-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.68-1.63-.93-2.23-.24-.59-.49-.5-.68-.51l-.58-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.1 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z"/>
                </svg>
              </a>
              <a href="mailto:sales@essesspharma.com"
                className="w-8 h-8 rounded-full bg-[#eef3f7] hover:bg-[#E53935] flex items-center justify-center transition-colors duration-200 group">
                <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-gray-400 group-hover:text-white" fill="currentColor">
                  <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 2l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* ── Col 3: Information ── */}
          <div className="lg:col-span-1">
            <h4 className="text-xs font-bold text-gray-800 uppercase tracking-widest mb-5">Information</h4>
            <ul className="space-y-3">
              {informationLinks.map(({ label, path }) => (
                <li key={label}>
                  <Link to={path} className="text-sm text-gray-500 hover:text-[#2badb8] transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 4: Categories ── */}
          <div className="lg:col-span-1">
            <h4 className="text-xs font-bold text-gray-800 uppercase tracking-widest mb-5">Categories</h4>
            <ul className="space-y-3">
              {categoryLinks.map(({ label, path }) => (
                <li key={label}>
                  <Link to={path} className="text-sm text-gray-500 hover:text-[#2badb8] transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 5: Address ── */}
          <div className="lg:col-span-1">
            <h4 className="text-xs font-bold text-gray-800 uppercase tracking-widest mb-5">Address</h4>
            <div className="flex items-start gap-2.5">
              <div className="w-7 h-7 rounded-full bg-[#eef3f7] flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg viewBox="0 0 24 24" fill="none" className="w-3.5 h-3.5 text-[#2badb8]" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1112 6.5a2.5 2.5 0 010 5z"/>
                </svg>
              </div>
              <p className="text-sm text-gray-500 leading-relaxed">
                FOB51888, Compass Building,<br />
                Al Shohada Road, AL Hamra<br />
                Industrial Zone-FZ,<br />
                Ras Al Khaimah, UAE
              </p>
            </div>
          </div>

          {/* ── Col 6: Contact ── */}
          <div className="lg:col-span-1">
            <h4 className="text-xs font-bold text-gray-800 uppercase tracking-widest mb-5">Contact Us</h4>
            <div className="space-y-5">
              {/* Call Us */}
              <div className="flex items-start gap-2.5">
                <div className="w-7 h-7 rounded-full bg-[#eef3f7] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg viewBox="0 0 24 24" fill="none" className="w-3.5 h-3.5 text-[#2badb8]" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 .01h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                </div>
                <div>
                  <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Call Us</p>
                  <a href="tel:+971503145829" className="text-sm font-bold text-[#2badb8] hover:text-[#1f8f99] transition-colors duration-200 block leading-tight">
                    +971 503145829
                  </a>
                  <a href="mailto:sales@essesspharma.com" className="text-xs text-gray-400 hover:text-[#2badb8] transition-colors duration-200 mt-0.5 block">
                    sales@essesspharma.com
                  </a>
                </div>
              </div>
              {/* WhatsApp */}
              <div className="flex items-start gap-2.5">
                <div className="w-7 h-7 rounded-full bg-[#eef3f7] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="#25D366">
                    <path d="M20.52 3.48A11.93 11.93 0 0012 0C5.37 0 0 5.37 0 12a11.9 11.9 0 001.64 6.08L0 24l6.1-1.6A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.22-3.48-8.52zM12 22a9.93 9.93 0 01-5.06-1.38l-.36-.21-3.74.98.99-3.63-.24-.38A9.94 9.94 0 012 12C2 6.48 6.48 2 12 2c2.65 0 5.15 1.03 7.03 2.9A9.9 9.9 0 0122 12c0 5.52-4.48 10-10 10zm5.47-7.38c-.3-.15-1.77-.87-2.04-.97-.28-.1-.48-.15-.68.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07a8.14 8.14 0 01-2.4-1.48 9 9 0 01-1.66-2.07c-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.68-1.63-.93-2.23-.24-.59-.49-.5-.68-.51l-.58-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.1 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z"/>
                  </svg>
                </div>
                <div>
                  <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wide mb-1">WhatsApp</p>
                  <a href="https://wa.me/971545012567" target="_blank" rel="noopener noreferrer"
                    className="text-sm font-bold text-[#25D366] hover:text-[#1da851] transition-colors duration-200 block leading-tight">
                    +971 545012567
                  </a>
                  <span className="text-xs text-gray-400 mt-0.5 block">Chat with us anytime</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* ── Disclaimer ── */}
        <div className="mt-10 bg-gray-50 rounded-2xl p-5 border border-gray-200 space-y-3">
          <h5 className="font-bold text-gray-900 text-sm">Disclaimer</h5>
          <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
            All content on this platform is intended for general informational purposes only. eSSeSSpharma does not offer professional medical advice, diagnosis, or treatment through this platform, and the information provided may contain errors, omissions, or may not reflect the latest regulatory or product developments. Please consult a qualified healthcare professional regarding any medical concerns.
          </p>
          <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
            All brand names and trademarks referenced on this website are the property of their respective originator companies. eSSeSSpharma claims no ownership or affiliation with any such brands. References are made solely for product identification purposes and do not imply any commercial relationship, sponsorship, approval, or association with any trademark owner. Trademark ownership has been accurately attributed under the &quot;Marketing/TM Owner&quot; section in compliance with statutory requirements. Any reference to, or dealing in, trademarked products is conducted consistent with applicable trademark and fair-use principles under UAE law, including Federal Law No. 36 of 2021 (Trademarks Law), and with the United Arab Emirates&apos; obligations as a WTO member under the TRIPS Agreement.
          </p>
          <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
            Nothing on this site constitutes an advertisement or offer for sale of a prescription medicine, and product availability is subject to applicable UAE laws, licensing requirements, and free zone regulations, as well as the regulations of the destination country. Buyers/importers are responsible for ensuring compliance with the pharmaceutical import and licensing regulations of their own country prior to purchase.
          </p>
          <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
            &quot;Trademark ownership is duly attributed under the &apos;Marketing/TM Owner&apos; section in accordance with applicable statutory requirements.&quot;
          </p>
          <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
            eSSeSSpharma accepts no liability for decisions made based on the information provided. This disclaimer is governed by the laws of the United Arab Emirates.
          </p>
        </div>

        {/* ── Divider ── */}
        <div className="mt-8 border-t border-gray-100" />

        {/* ── Bottom bar ── */}
        <div className="mt-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[12px] text-gray-400 text-center sm:text-left">
            © 2018–{currentYear}{" "}
            <span className="font-semibold text-gray-500">eSSeSSpharma</span>. All Rights Reserved.
          </p>
          <div className="flex gap-5 text-[12px]">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-[#2badb8] transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" className="text-gray-400 hover:text-[#2badb8] transition-colors duration-200">
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>

      {/* ── Scroll to top ── */}
      {/* TEMPORARILY DISABLED
      <AnimatePresence>
        {showScrollTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.2 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-24 right-6 w-10 h-10 rounded-full flex items-center justify-center z-50 shadow-lg hover:scale-110 transition-transform duration-200 bg-[#2badb8]"
            aria-label="Scroll to top"
          >
            <ArrowUp className="w-4 h-4 text-white" />
          </motion.button>
        )}
      </AnimatePresence>
      */}

      </footer>

      {/* ── WhatsApp Floating Button ── */}
      <style>{`
        @keyframes wa-pulse {
          0%   { box-shadow: 0 0 0 0 rgba(37,211,102,0.55); }
          70%  { box-shadow: 0 0 0 12px rgba(37,211,102,0); }
          100% { box-shadow: 0 0 0 0 rgba(37,211,102,0); }
        }
        .wa-btn { animation: wa-pulse 2s ease-out infinite; }
        .wa-btn:hover { animation: none; transform: scale(1.12); }
      `}</style>
      <a
        href="https://wa.me/971545012567"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className={`wa-btn fixed bottom-4 right-4 sm:bottom-6 sm:right-6 w-12 h-12 rounded-full shadow-lg items-center justify-center z-[9999] transition-transform ${isMedicineDetailPage ? 'hidden lg:flex' : 'flex'}`}
        style={{
          background: '#25D366',
          right: 'max(1rem, env(safe-area-inset-right, 0px))',
          bottom: 'max(1rem, env(safe-area-inset-bottom, 0px))',
        }}
      >
        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="#FFFFFF">
          <path d="M20.52 3.48A11.93 11.93 0 0012 0C5.37 0 0 5.37 0 12a11.9 11.9 0 001.64 6.08L0 24l6.1-1.6A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.22-3.48-8.52zM12 22a9.93 9.93 0 01-5.06-1.38l-.36-.21-3.74.98.99-3.63-.24-.38A9.94 9.94 0 012 12C2 6.48 6.48 2 12 2c2.65 0 5.15 1.03 7.03 2.9A9.9 9.9 0 0122 12c0 5.52-4.48 10-10 10zm5.47-7.38c-.3-.15-1.77-.87-2.04-.97-.28-.1-.48-.15-.68.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07a8.14 8.14 0 01-2.4-1.48 9 9 0 01-1.66-2.07c-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.68-1.63-.93-2.23-.24-.59-.49-.5-.68-.51l-.58-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.1 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z"/>
        </svg>
      </a>
    </>
  );
}
